import React from 'react';

import Footer from '../../components/innerpage/Footer';
import Navbar2 from '../../components/innerpage/Navbar2';

import Header from '../../components/innerpage/portfolio/Header';
import LatestCases from '../../components/innerpage/portfolio/LatestCases';
import { Helmet } from 'react-helmet';

function PortfolioPage() {
  return (
    <>
      <Helmet>
        <link
          rel="stylesheet"
          type="text/css"
          href="/innerpages/assets/css/innerpages.css"
        />
        <script src="/common/assets/js/common_js.js"></script>
        <script src="/innerpages/assets/js/innerpages.js"></script>
      </Helmet>
      <body className="inner-pages-style1 portfolio-pg-style1">

        <div className="smooth-scroll-content" id="scrollsmoother-container">
          <Navbar2 />
          <Header />
          <main>

            <LatestCases />


          </main>
          <Footer />
        </div>

      </body>
    </>
  );
}

export default PortfolioPage;
